import { createAsyncThunk } from '@reduxjs/toolkit';

import { getLocalStorageSafe } from '~/lib/utils/getLocalStorageSafe';

const favoriteGenresCheckboxName = 'favoriteGenresCheckbox';

export const loadFavoriteGenresCheckboxFromStorage = createAsyncThunk<
{ isShowAllGenres: boolean } | undefined
>(
  'loadFavoriteGenresCheckboxFromStorage',
  async () => {
    const storage = getLocalStorageSafe();
    if (storage) {
      try {
        const data = storage.getItem(favoriteGenresCheckboxName);
        return data ? JSON.parse(data) : undefined;
      } catch (error) {
        console.error('Failed to load favorite genres checkbox:', error);
      }
    }
    return undefined;
  },
);

export const saveFavoriteGenresCheckboxFromStorage = createAsyncThunk<
void,
{ isShowAllGenres: boolean }
>(
  'saveFavoriteGenresCheckboxFromStorage',
  async (data) => {
    const storage = getLocalStorageSafe();
    if (storage) {
      try {
        storage.setItem(favoriteGenresCheckboxName, JSON.stringify(data));
      } catch (error) {
        console.error('Failed to save favorite genres checkbox:', error);
      }
    }
  },
);
